<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.showFretNumber" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="showFretNumber" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.chordName" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="chordName" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.chordDescription" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="chordDescription" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="6" xs24 v-for="(chord, index) in chords" :key="index">
        <card full-height>
          <card-text>
            <chord-diagram
              :color="$dark ? '#fff' : '#000'"
              :dot-font-color="$dark ? '#000' : '#fff'"
              :positions="chord.positions"
              :start-at="chord.startAt"
              :name="chordName ? chord.name : null"
              :show-fret-number="showFretNumber"
              :description="chordDescription ? chord.description : null" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageChordDiagram',
  mixins: [
    methods
  ],
  data () {
    return {
      chords: [],
      chordName: true,
      chordDescription: true,
      showFretNumber: true
    }
  },
  mounted () {
    this.getExternalData('chord-diagram.json', 'chords')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/chord-diagram.vue